import { render, staticRenderFns } from "./qaDetail.vue?vue&type=template&id=601d92ec&scoped=true&"
import script from "./qaDetail.vue?vue&type=script&lang=js&"
export * from "./qaDetail.vue?vue&type=script&lang=js&"
import style0 from "./qaDetail.vue?vue&type=style&index=0&id=601d92ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d92ec",
  null
  
)

export default component.exports